module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gradeCalcPage"
  }, [_c('div', {
    staticClass: "logos"
  }, [_c('img', {
    attrs: {
      "src": require(".././assets/loyola.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require(".././assets/northwestern.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29a6ad46","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GradeCalcPage.vue
// module id = 23
// module chunks = 0